export default __webpack_public_path__ + "static/media/custom-dtf-blindship.df8f8ab6.png";